import styled from 'react-emotion';

const Content = styled('div')`
  flex: 4;
`;

export default Content;



// WEBPACK FOOTER //
// ./src/components/content.js